import { Button } from '@/components/ui/button';
import { CheckCircle2 } from 'lucide-react';

interface AccountingImportSuccessProps {
  count: number;
  systemName: string;
  onViewAssets: () => void;
  importedAssetIds?: string[];
}

export default function AccountingImportSuccess({
  count,
  systemName,
  onViewAssets,
  importedAssetIds
}: AccountingImportSuccessProps) {
  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-200px)]">
      <div className="bg-white rounded-2xl shadow-xl shadow-slate-200/50 p-12 max-w-md w-full">
        <div className="flex flex-col items-center justify-center space-y-6">
          <div className="rounded-full bg-green-100 p-6">
            <CheckCircle2 className="h-16 w-16 text-green-600" />
          </div>

          <div className="text-center space-y-2">
            <h2 className="text-2xl font-semibold text-slate-800">
              {count} asset{count !== 1 ? 's' : ''} imported
            </h2>
            <p className="text-slate-500">from {systemName}</p>
          </div>

          <Button onClick={onViewAssets} className="w-full">
            View Imported Assets
          </Button>
        </div>
      </div>
    </div>
  );
}
